import { Action } from '@ngrx/store';

export enum UserActions {
    GetRoles = '[Roles] Get Roles',
    GetUserRoles = '[User Roles] User Roles',
}

export class GetRoles implements Action {
    readonly type = UserActions.GetRoles;
}

export class GetUserRoles implements Action {
    readonly type = UserActions.GetUserRoles;
    constructor(public payload: any) {}
}

export type UserAction = GetRoles | GetUserRoles;
